// extracted by mini-css-extract-plugin
export default {"signatureField":"ssW2_O","header":"seBM7k","inputContainer":"g5EYrx"};